var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 13.5,
    stroke: "#E7EAED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2735 18.2741H24.5248H21.7253V11.7259C21.7253 10.7726 20.9527 10 19.9994 10C19.0461 10 18.2735 10.7726 18.2735 11.7259V18.2741H11.7259C10.7726 18.2741 10 19.0467 10 20C10 20.9533 10.7726 21.7259 11.7259 21.7259H18.2741V23.193V28.2741C18.2741 29.2274 19.0467 30 20 30C20.9533 30 21.7259 29.2274 21.7259 28.2741V21.7259H28.2741C29.2274 21.7259 30 20.9533 30 20C30 19.0467 29.2268 18.2741 28.2735 18.2741Z",
    fill: "#40556A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocIcon);
export default __webpack_public_path__ + "static/media/locIcon.14f0ce375a7a8d07cdfb3e982ffbd30c.svg";
export { ForwardRef as ReactComponent };